import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
@Component({
  selector: 'app-auction',
  templateUrl: './auction.component.html',
  styleUrls: ['./auction.component.scss']
})
export class AuctionComponent extends DestructorComponent {
  masterDataChildren: Route[] = [];
  user:any;

  constructor(private router: Router, private _globalStateService: GlobalStateService) { super(); }

  ngOnInit(): void {
    const masterDataRoute:any = this.router.config.find(r => r.path === 'bid-manager');

    let routeAuctionChildren = masterDataRoute?.children ?? [];
    // Get only first-level children
    this.masterDataChildren = masterDataRoute?.children ?? [];

    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;

        if(this.user?.role_complete.is_admin){
            this.masterDataChildren = masterDataRoute?.children ?? [];
        }
        else{
            this.masterDataChildren = routeAuctionChildren.filter((child:any) => {
              return this.user?.role_complete.permissions[child.path]?.view;
            });
        }
      })
    );
  }
}
